import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import { Toaster } from "./components/ui/toaster";

import Home from "./pages/Home";
import About from "./pages/About";
import OudChips from "./pages/OudChips";
import OudOil from "./pages/OudOil";
import Bakhoor from "./pages/Bakhoor";
import OtherProducts from "./pages/OtherProducts";
import House from "./pages/House";
import Recognitions from "./pages/Recognitions";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import BlendFinder from "./pages/BlendFinder";
import Gallery from "./pages/Gallery";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const Chrome = ({ children }) => {
  const { pathname } = useLocation();
  const bare = pathname.startsWith("/admin");
  return (
    <>
      {!bare && <Navbar />}
      <main>{children}</main>
      {!bare && <Footer />}
      {!bare && <FloatingWhatsApp />}
    </>
  );
};

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <ScrollToTop />
        <Chrome>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/oud-chips" element={<OudChips />} />
            <Route path="/oud-oil" element={<OudOil />} />
            <Route path="/bakhoor" element={<Bakhoor />} />
            <Route path="/other-products" element={<OtherProducts />} />
            <Route path="/house" element={<House />} />
            <Route path="/recognitions" element={<Recognitions />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blend-finder" element={<BlendFinder />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </Chrome>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
